import React from 'react';
import PropTypes from 'prop-types';

import { VpInfoMenu } from '@vp-ui/components';
import { useVpSnackbar } from '@vp-ui/hooks';
import { handleCopyCampaignLink } from '@src/helpers/campaignHelper';
import { generateEmbeddedIframe } from '@src/helpers/embediFrameHelper';
import { buildLibraryUrl } from '@src/helpers/videoCompilationHelper';

const menuItems = [
  {
    id: 'copy',
    label: 'Copy Link',
    icon: 'Link2'
  },
  {
    id: 'share',
    label: 'Embedd iFrame',
    icon: 'Share2'
  }
];

export const VpVideoCompilationInfoMenu = ({ vcpId, pageLink }) => {
  const { addSnackbarInfo } = useVpSnackbar();

  const onSelect = (item, e) => {
    const link = `${window?.location?.origin}${buildLibraryUrl(pageLink)}`;

    switch (item?.id) {
      case 'copy': {
        handleCopyCampaignLink(e, link, false);
        addSnackbarInfo({ message: 'Copied link to clipboard', title: '' });
        return;
      }

      case 'share': {
        handleCopyCampaignLink(e, generateEmbeddedIframe({ link }), false);
        addSnackbarInfo({
          message: "Now paste into your website's html code!",
          title: 'Copied iframe to clipboard'
        });
        return;
      }
    }
  };

  return <VpInfoMenu id={vcpId} menuItems={menuItems} onSelect={onSelect} />;
};

VpVideoCompilationInfoMenu.propTypes = {
  vcpId: PropTypes.string,
  pageLink: PropTypes.string
};

export default VpVideoCompilationInfoMenu;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpVideoCompilationTable/VpVideoCompilationsInfoMenu.jsx